var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 23,
    viewBox: "0 0 56 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 56,
    height: 22,
    rx: 6,
    fill: "#1EB386"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11.5,
    r: 3.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5028 6.77273V15.5H28.2926L23.8565 9.09943H23.7756V15.5H22.4588V6.77273H23.6776L28.1179 13.1818H28.1989V6.77273H29.5028ZM34.0224 15.6321C33.3775 15.6321 32.8221 15.4943 32.3562 15.2188C31.8931 14.9403 31.5352 14.5497 31.2823 14.0469C31.0323 13.5412 30.9073 12.9489 30.9073 12.2699C30.9073 11.5994 31.0323 11.0085 31.2823 10.4972C31.5352 9.9858 31.8875 9.58665 32.3392 9.29972C32.7937 9.01278 33.325 8.86932 33.9329 8.86932C34.3022 8.86932 34.6602 8.9304 35.0068 9.05256C35.3534 9.17472 35.6644 9.36648 35.94 9.62784C36.2156 9.8892 36.4329 10.2287 36.592 10.6463C36.7511 11.0611 36.8306 11.5653 36.8306 12.1591V12.6108H31.6275V11.6562H35.5821C35.5821 11.321 35.5139 11.0241 35.3775 10.7656C35.2412 10.5043 35.0494 10.2983 34.8022 10.1477C34.5579 9.99716 34.271 9.92188 33.9414 9.92188C33.5835 9.92188 33.271 10.0099 33.0039 10.1861C32.7397 10.3594 32.5352 10.5866 32.3903 10.8679C32.2483 11.1463 32.1772 11.4489 32.1772 11.7756V12.5213C32.1772 12.9588 32.2539 13.331 32.4073 13.6378C32.5636 13.9446 32.7809 14.179 33.0593 14.3409C33.3377 14.5 33.663 14.5795 34.0352 14.5795C34.2767 14.5795 34.4968 14.5455 34.6957 14.4773C34.8946 14.4062 35.0664 14.3011 35.2113 14.1619C35.3562 14.0227 35.467 13.8509 35.5437 13.6463L36.7497 13.8636C36.6531 14.2187 36.4798 14.5298 36.2298 14.7969C35.9826 15.0611 35.6715 15.267 35.2965 15.4148C34.9244 15.5597 34.4997 15.6321 34.0224 15.6321ZM39.5317 15.5L37.6055 8.95455H38.9223L40.205 13.7614H40.2689L41.5558 8.95455H42.8726L44.151 13.7401H44.2149L45.489 8.95455H46.8058L44.8839 15.5H43.5842L42.2547 10.7741H42.1567L40.8271 15.5H39.5317Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCustomer);
export default __webpack_public_path__ + "static/media/New_Customer.b753eb0b8669b6364583a41e837c8f7f.svg";
export { ForwardRef as ReactComponent };